




























































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'
import moment from 'moment'
import { DictRequest, DictParam, DictOptions, DictFilter } from '@/types'

@Component({ name: 'Tools' })
export default class Tools extends Vue {
  pickerFrom = false
  askFrom = false
  pickerTo = false
  dateFrom = moment().format('YYYY-MM-DD')
  dateTo = moment().format('YYYY-MM-DD')
  dateAskFrom = moment().format('YYYY-MM-DD')
  tzoffset = 0
  transport = ''
  show = false
  askresult = ''
  delFrom = false
  delTo = false
  delDateFrom = moment().format('YYYY-MM-DD')
  delDateTo = moment().format('YYYY-MM-DD')
  pickerGalaxySendFrom = false
  pickerGalaxySendTo = false
  dateGalaxySendFrom = moment().format('YYYY-MM-DD')
  dateGalaxySendTo = moment().format('YYYY-MM-DD')
  response = ''

  get lists () {
    return EPLModule.lists
  }

  get loading () {
    return EPLModule.loading
  }

  get dateFormattedGalaxySendFrom () {
    return moment.unix(this.getUnixTime(this.dateGalaxySendFrom)).format('DD.MM.YYYY')
  }

  get dateFormattedGalaxySendTo () {
    return moment.unix(this.getUnixTime(this.dateGalaxySendTo)).format('DD.MM.YYYY')
  }

  mounted () {
    this.tzoffset = new Date().getTimezoneOffset() * 60
    const interval = setInterval(() => {
      if (EPLModule.lists['Transport-gosnumber,marka' as any] !== undefined) {
        if (EPLModule.lists['Transport-gosnumber,marka' as any].length > 0) {
          this.show = true
          clearInterval(interval)
        }
      }
    }, 100)
  }

  private getASK () {
    this.askresult = ''
    EPLModule.massGlonass({ beg: this.getUnixTime(this.dateAskFrom) })
      .then((response: any) => {
        response.data.forEach((s: string) => {
          this.askresult += s
          this.askresult += '\n'
        })
      })
  }

  private getArch () {
    EPLModule.getArchEPL({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399, transport: this.transport })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

  private delEPL () {
    if (confirm('Удалить ЭПЛ за выбранный период?')) {
      EPLModule.delEPL({ beg: this.getUnixTime(this.delDateFrom), end: this.getUnixTime(this.delDateTo) + 86399 })
    }
  }

  private getUnixTime (date: string): number {
    return parseInt(
      ((new Date(date).getTime() / 1000) + this.tzoffset).toFixed(0)
    )
  }

  get dateFormattedAskFrom () {
    return moment.unix(this.getUnixTime(this.dateAskFrom)).format('DD.MM.YYYY')
  }

  get dateFormattedFrom () {
    return moment.unix(this.getUnixTime(this.dateFrom)).format('DD.MM.YYYY')
  }

  get dateFormattedTo () {
    return moment.unix(this.getUnixTime(this.dateTo)).format('DD.MM.YYYY')
  }

  get delDateFormattedFrom () {
    return moment.unix(this.getUnixTime(this.delDateFrom)).format('DD.MM.YYYY')
  }

  get delDateFormattedTo () {
    return moment.unix(this.getUnixTime(this.delDateTo)).format('DD.MM.YYYY')
  }

  private send () {
    // -----===------
    // this.response = ''
    // EPLModule.galaxySend({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399 })
    //   .then((response: any) => {
    //     this.response = JSON.stringify(response.data)
    //     const url = window.URL.createObjectURL(new Blob([this.response], { type: 'plain/text' }))
    const link = document.createElement('a')
    // let filename = response.headers['content-disposition']
    // filename = filename.substr(filename.search(/"/g) + 1)
    // filename = filename.substr(0, filename.search(/"/g))
    link.href = `/api/galaxysend/${this.getUnixTime(this.dateGalaxySendFrom)}/${this.getUnixTime(this.dateGalaxySendTo) + 86399}`
    link.setAttribute('download', 'galaxy.txt')
    document.body.appendChild(link)
    link.click()
    // })
  }

  private sendToGalaxy () {
    EPLModule.eplToGalaxyDirect({ from: this.getUnixTime(this.dateGalaxySendFrom), to: this.getUnixTime(this.dateGalaxySendTo) + 86399 })
  }

  private serial () {
    EPLModule.testLocalhost()
  }
}
